<template>
  <v-card v-resize="onResize" class="ma-2 pa-2">
    <v-card-text>
      <p class="text-center title pb-0 mb-0 font-weight-regular">Water Distribution (Gallons)</p>
    </v-card-text>
    <div ref='waterSankey' class="pt-0 mt-0" style='height:500px;width:100%'></div>
  </v-card>
</template>

<script>
import shine   from '@/components/plugins/echarts-theme-shine';
import waterData from '@/assets/waterDataV3.json';

export default{
  data: () => ({
    dataZoom: null,
    waterSankey: null,
    cisternVolumeChart: null,
    waterCollectionRate: 5000, //gpm
    waterConsumptionRate: 4500, //gpm
    minDate: Date.parse('January 01, 2019'),
    maxDate: Date.parse('December 31, 2019'),
    msPerDay: 86400000,
    dateRange: [Date.parse('January 01, 2019'),Date.parse('December 31, 2019')],
    lowerDateString: '1/01/2019',
    upperDateString: '12/31/2019',
    greywaterTreatmentBreakdown: true,
    compostersBreakdown: true,
    waterFountainsBreakdown: true,
    toiletsBreakdown: true,
    urinalsBreakdown: true,
    potableWaterTankBreakdown: true,
    filtrationBreakdown: true,
    condensateTankBreakdown: true,
    HVACCondensateBreakdown: true,
    cisternBreakdown: true,
    holidays: ['1/1','1/21','5/27','7/4','9/2','11/28','11/29','12/23','12/24','12/25','12/26','12/27'],
    breakDays: ['1/2','1/3','1/4','1/5','1/6','3/18','3/19','3/20','3/21','3/22','5/6','5/7','5/8','5/9','5/10','7/5','8/5','8/6','8/7','8/8','8/9','8/12','8/13','8/14','8/15','8/16','10/14','10/15','11/27','12/16','12/17','12/18','12/19','12/20'],
    water: {
      dailyBase: {

      },
      monthCoefficients: {
      },
      totals: {

      },
    },
  }),
  methods: {
    getLowerDate(){
      //console.log(this.minDate)
      let d = new Date(this.dateRange[0]);
      this.lowerDateString = d.toLocaleDateString();
    },
    getUpperDate(){
      let d = new Date(this.dateRange[1]);
      this.upperDateString = d.toLocaleDateString();
    },
    toggleData(params){
      if(params.data.name=='Composters'){
        this.compostersBreakdown=!this.compostersBreakdown;
        this.refreshWaterSankey;
      }else if(params.data.name=='Fountains'){
        this.waterFountainsBreakdown=!this.waterFountainsBreakdown;
        this.refreshWaterSankey;
      }else if(params.data.name=='Toilets'){
        this.toiletsBreakdown=!this.toiletsBreakdown;
        this.refreshWaterSankey;
      }else if(params.data.name=='Urinals'){
        this.urinalsBreakdown=!this.urinalsBreakdown;
        this.refreshWaterSankey;
      }else if(params.data.name=='Water\nDemand'){
        this.potableWaterTankBreakdown=!this.potableWaterTankBreakdown;
        this.refreshWaterSankey;
      }else if(params.data.name=='Filtration/\nDay Tanks'){
        this.filtrationBreakdown=!this.filtrationBreakdown;
        this.refreshWaterSankey;
      }else if(params.data.name=='Irrigation'){
        this.condensateTankBreakdown=!this.condensateTankBreakdown;
        this.refreshWaterSankey;
      }else if(params.data.name=='Cistern\nDraw'){
        this.cisternBreakdown=!this.cisternBreakdown;
        this.refreshWaterSankey;
      }else if(params.data.name=='Treatment'){
        this.greywaterTreatmentBreakdown=!this.greywaterTreatmentBreakdown;
        this.refreshWaterSankey;
      }
    },
    changeDataZoom(){
      this.refreshWaterSankey;
    },
    onResize() {
      if(this.waterSankey) _.debounce(this.waterSankey.resize,100)()
      // if(this.cisternVolumeChart) _.debounce(this.cisternVolumeChart.resize, 100)()
      // if(this.dataZoom)_.debounce(this.dataZoom.resize,100)()
    },
  },
  watch: {
    startDate: function(newDates,oldDates){
      this.refreshWaterSankey;
    },
    endDate: function(newDates,oldDates){
      this.refreshWaterSankey;
    },
    selectedTimes: function(newTimes,oldTimes){
      this.refreshWaterSankey;
    },
    cisternCapacity: function(newCapacity,oldCapacity){
      this.refreshWaterSankey;
    },
    toiletKfactor: function(newKfactor,oldKfactor){
      this.refreshWaterSankey;
    },
    faucetKfactor: function(newKfactor,oldKfactor){
      this.refreshWaterSankey;
    }
  },
  computed: {
    getWaterData(){
      return (waterData)
    },
    startDate(){
      return this.$store.state.startDateInd;
    },
    endDate(){
      return this.$store.state.endDateInd;
    },
    selectedTimes(){
      return this.$store.state.selectedTimes;
    },
    cisternCapacity(){
      return this.$store.state.water.cisternCapacity;
    },
    toiletName(){
      return this.$store.state.water.toilet;
    },
    toiletKfactor(){
      return this.$store.state.water.kFactors.toilets;
    },
    faucetName(){
      return this.$store.state.water.faucet;
    },
    faucetKfactor(){
      return this.$store.state.water.kFactors.faucets;
    },
    filterData(){
      let filteredData = this.getWaterCorrections.filter(data => new Date(data.Time) >= new Date(this.dateData[this.startDate]) && new Date(data.Time) <= new Date(this.dateData[this.endDate]+' 23:00:00'));
      return this.getWaterCorrections;
    },
    dateData(){
      let dateData = [...new Set(waterData.map(({Time}) => new Date(Time).toISOString().substring(0, 10)))];
      if(dateData[dateData.length-1]=='12/31/1969'){
        dateData.pop();
      }
      return dateData;
    },
    refreshWaterSankey(){
        const waterSankeyOption = {
          // title: {
          //   left: 'center',
          //   text: 'Water Distribution (Gallons)',
          // },
          grid: {
            top: 0,
          },
          tooltip: {
            show: true,
            trigger: 'item',
            triggerOn: 'mousemove',
            formatter: function(params, ticket, callback) {
              let tooltipStr = '';
              if(params.dataType == 'node'){
                if(params.name.includes('Filler')){
                  tooltipStr = '';
                }else if(params.name.includes('fake')){
                  tooltipStr = '';
                }else{
                  tooltipStr = params.name + ': ' + params.value;
                }
              }else if(params.dataType == 'edge'){
                if(params.name.includes('Filler')){
                  tooltipStr = '';
                }else if(params.name.includes('fake')){
                  tooltipStr = '';
                }else{
                  tooltipStr = params.data.source + ' -- ' + params.data.target + ' : ' + params.value;
                }
              }
              return tooltipStr
            }
          },
          series: [
          {
              type: 'sankey',
              top: 15,
              layout: 'none',
              nodeAlign: 'top',
              focusNodeAdjacency: 'allEdges',
              layoutIterations: 0,
              lineStyle: {
                  normal: {
                      color: 'source',
                      curveness: 0.5
                  }
              },
              // tooltip: {
              //   trigger: 'item',
              // },
              // label: {
              //   formatter: '{b}\n{c}'
              // },
              data: this.sankeyData,
              links: this.sankeyLinks,
          },
          ],
        };
        this.waterSankey.setOption(waterSankeyOption,true);
    },
    sankeyData: function() {
      // let cisternVolumeData = this.filterData.map(currentValue => currentValue.CisternVolumegal);
      // console.log(Math.max(...cisternVolumeData,this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0)))
        //push(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0))))
      let treatmentData = this.getWaterTotals.treatmentData;
      let toiletData = this.getWaterTotals.toiletData;
      let sinkData = this.getWaterTotals.sinkData;
      let potableWaterTankData = this.getWaterTotals.potableWaterTankData;
      let filtrationData = this.getWaterTotals.filtrationData;
      let overflowData = this.getWaterTotals.overflowData;
      let cisternFlowData = this.getWaterTotals.cisternFlowData;
      let cityWaterData = this.getWaterTotals.cityWaterData;
      let rainToIrrigationData = this.getWaterTotals.rainToIrrigationData;
      let cisternToIrrigationData = this.getWaterTotals.cisternToIrrigationData;
      let cityWaterToIrrigationData = this.getWaterTotals.cityWaterToIrrigationData;

      let nodeData = [
        {name: 'City Water', value: Math.round(cityWaterData), itemStyle: {color: '#C1554E'}, label: {color: '#C1554E'},},
        {name: 'Cistern\nDraw', value: Math.round(-1*cisternFlowData), itemStyle: {color:'#004D8C'}},// - this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0)), itemStyle: {color:'#004D8C'}},
        {name: 'Filtration/\nDay Tanks', value: Math.round(potableWaterTankData + this.filterData.reduce((total,arr)=>total+arr.FiltrationBlowdowngal,0)), itemStyle: {color:'#a8cfff'}},
        {name: 'Rain\nCollection', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0)), itemStyle: {color:'#004D8C'}}, //gal
        // {name: 'Filler1', value: 0.00001, itemStyle: {opacity: 0,}},
        // {name: 'Cistern\nThroughput', value: cisternFlowData, itemStyle: {color:'#004D8C'}},
         // {name: 'Catchment', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0)), itemStyle: {color:'#316B8F'}},
         // {name: 'Losses', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.NotCaughtRaingal,0)), itemStyle: {color:'#004D8C'}},
         // {name: 'Overflow', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0))},
         {name: 'Blowdown', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.FiltrationBlowdowngal,0)), itemStyle: {color:'#6B983C'}},
         // {name: 'Water\nDemand', value: potableWaterTankData, itemStyle: {color:'#a8cfff'}},
         {name: 'Sinks', value:  Math.round(sinkData), itemStyle: {color:'#a8cfff'}},
         {name: 'Showers', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Showersgal,0)), itemStyle: {color:'#a8cfff'}},
         {name: 'Misc.', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Miscellaneousgal,0)), itemStyle: {color:'#a8cfff'}},
         {name: 'Fountains', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.WaterFountainsgal,0)), itemStyle: {color:'#a8cfff'}},
         {name: 'Toilets', value:  Math.round(toiletData), itemStyle: {color:'#a8cfff'}},
         {name: 'Treatment', value:  Math.round(treatmentData), itemStyle: {color:'#6B983C'}},
         {name: 'Consumption', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Consumptiongal,0)), itemStyle: {color:'#a8cfff'}},
         {name: 'Composters', value:  Math.round(toiletData), itemStyle: {color:'#85503A'}},
         {name: 'Filler3a', depth: 3, value: 0.000001, itemStyle: {opacity: 0}},
         {name: 'Urinals', depth: 3, value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Urinalsgalofpee,0)), itemStyle: {color:'#85503A'}},
         {name: 'Constructed\nWetlands', value: Math.round(treatmentData), itemStyle: {color:'#6B983C'}},
         {name: 'Biosolids', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.Biosolidsgal,0)), itemStyle: {color:'#85503A'}},
         {name: 'Leachate', depth: 4, value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Urinalsgalofpee + this.toiletKfactor*arr.LeavingCompostersasLeachategal,0)), itemStyle: {color:'#85503A'}},
         {name: 'Filler3b', depth: 3, value: Math.round(rainToIrrigationData + cisternToIrrigationData + cityWaterToIrrigationData), itemStyle: {opacity: 0}},
         {name: 'HVAC\nCondensate', depth: 3, value: Math.round(this.filterData.reduce((total,arr)=>total+arr.HVACCondensategal,0)), itemStyle: {color:'#C7A754'}},
         {name: 'Irrigation', depth: 4, value: Math.round(this.filterData.reduce((total,arr)=>total+arr.HVACCondensategal+arr.CisterntoCondensategal,0)), itemStyle: {color:'#C7A754'}},
         {name: 'Stormwater\nManagement', value: Math.round(overflowData), itemStyle: {color:'#004D8C'}},
      ];

      // if no composting, delete composters and biosolids nodes and create sewer node
      // reduce leachate value since toilets will no longer go there
      if(!this.toiletName.includes('Compost')){
        nodeData = nodeData.filter(node => node.name !== 'Composters' && node.name !== 'Biosolids')
        nodeData[nodeData.findIndex((node)=>node.name == 'Leachate')].value = Math.round(this.filterData.reduce((total,arr)=>total+arr.Urinalsgalofpee,0));
        nodeData[nodeData.findIndex((node)=>node.name == 'Filler3a')].value = Math.round(toiletData);
        // nodeData[20].value = Math.round(this.filterData.reduce((total,arr)=>total+arr.Urinalsgalofpee,0));
        // nodeData.splice(19,1);
        // nodeData.splice(15,1);
        nodeData.splice(nodeData.findIndex(node => node.name == 'Leachate'),0,{name: 'Sewers', depth: 4, value:  Math.round(toiletData), itemStyle: {color:'#85503A'}});
      }
      // if cistern is getting filled change node name and sign of value
      if(Math.round(cisternFlowData)>0){
        nodeData[nodeData.findIndex((node)=>node.name == 'Cistern\nDraw')].value = 0;
        nodeData.push({name: 'Cistern\nFill', value:  Math.round(cisternFlowData), itemStyle: {color:'#004D8C'}});
      }

      //remove any nodes that don't have any values
      nodeData = nodeData.filter(node => node.value !== 0);

      // Implement 'folding' of sankey levels
      if (!this.compostersBreakdown){
        nodeData = nodeData.filter(e => e.name !== 'Biosolids');
      };
      if (!this.greywaterTreatmentBreakdown){
        nodeData = nodeData.filter(e => e.name !== 'Constructed\nWetlands' && e.name !== 'Filler5');
      };
      if (!this.waterFountainsBreakdown){
        nodeData = nodeData.filter(e => e.name !== 'Consumption');
      };
      if (!this.toiletsBreakdown){
        nodeData = nodeData.filter(e => e.name !== 'Biosolids');
      };
      // if (!this.potableWaterTankBreakdown){
      //   nodeData = nodeData.filter(e => e.name == 'Rain\nCollection' || e.name == 'Cistern\nThroughput' || e.name == 'HVAC\nCondensate' || e.name == 'Irrigation' || e.name == 'Filtration' || e.name == 'Stormwater\nManagement' || e.name == 'Blowdown' || e.name == 'Filler1' || e.name == 'Filler2' || e.name == 'From\nCistern' || e.name == 'City Water' );
      // };
      if (!this.filtrationBreakdown){
        nodeData = nodeData.filter(e => e.name == 'Rain\nCollection' || e.name == 'Cistern\nDraw' || e.name == 'HVAC\nCondensate' || e.name == 'Irrigation' || e.name == 'Filtration/\nDay Tanks' || e.name == 'Stormwater\nManagement' || e.name == 'Filler1' || e.name == 'Filler2' || e.name == 'Cistern\nFill' || e.name == 'City Water');
      };
      if (!this.cisternBreakdown){
        nodeData = nodeData.filter(e => e.name == 'Rain\nCollection' || e.name == 'Cistern\nThroughput' || e.name == 'HVAC\nCondensate' || e.name == 'Irrigation' || e.name == 'From\nCistern' || e.name == 'City Water' || e.name == 'Filler1' || e.name == 'Filler2');
      };
      // console.log(nodeData)
      return nodeData;
    },
    sankeyLinks: function(){
      let treatmentData = this.getWaterTotals.treatmentData;
      let sinkData = this.getWaterTotals.sinkData;
      let toiletData = this.getWaterTotals.toiletData;
      let potableWaterTankData = this.getWaterTotals.potableWaterTankData;
      let filtrationData = this.getWaterTotals.filtrationData;
      let overflowData = this.getWaterTotals.overflowData;
      let cisternFlowData = this.getWaterTotals.cisternFlowData;
      let cityWaterData = this.getWaterTotals.cityWaterData;
      let rainToOverflowData = this.getWaterTotals.rainToOverflowData;
      let rainToIrrigationData = this.getWaterTotals.rainToIrrigationData;
      let rainToFiltrationData = this.getWaterTotals.rainToFiltrationData;
      let cisternToIrrigationData = this.getWaterTotals.cisternToIrrigationData;
      let cisternToFiltrationData = this.getWaterTotals.cisternToFiltrationData;
      let cityWaterToIrrigationData = this.getWaterTotals.cityWaterToIrrigationData;
      let cityWaterToFiltrationData = this.getWaterTotals.cityWaterToFiltrationData;
      // let cisternVolumeData = this.filterData.map((currentValue)=>{currentValue.CisternVolumegal});
      // console.log(rainToFiltrationData);
      let linkData = [
        // {source: 'Rain\nCollection', target: 'Cistern\nThroughput', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0))},
        {source: 'Cistern\nDraw', target: 'Filtration/\nDay Tanks', value: Math.round(cisternToFiltrationData)},//Math.round(cisternFlowData - (this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal+arr.Rainbeingcapturedgal,0)-Math.min(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0)-overflowData, this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0))))},
        {source: 'Cistern\nDraw', target: 'Irrigation', value: Math.round(cisternToIrrigationData)},//this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0)-Math.min(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0)-overflowData,this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0)))},
        // {source: 'Filler1', target: 'HVAC\nCondensate', value: 0.00001, lineStyle: {opacity: 0,},},
        // {source: 'Rain', target: 'Losses', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.NotCaughtRaingal,0))},
        // {source: 'Catchment', target: 'Cistern', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0))},
        // {source: 'Condensate\nTank', target: 'Filler3', value: 0.00001, lineStyle: {opacity: 0,},},
        {source: 'HVAC\nCondensate', target: 'Irrigation', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.HVACCondensategal,0))},
        {source: 'Rain\nCollection', target: 'Irrigation', value: Math.round(rainToIrrigationData)},//Math.min(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0)-overflowData, this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0)))},
        {source: 'Rain\nCollection', target: 'Stormwater\nManagement', value: Math.round(overflowData)},
        // {source: 'Overflow', target: 'Filler3', value: 0.00001, lineStyle: {opacity: 0,}},
        {source: 'Rain\nCollection', target: 'Filtration/\nDay Tanks', value:  Math.round(rainToFiltrationData)},//Math.min(Math.max(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal-arr.CisterntoCondensategal,0)-overflowData,0),filtrationData))},
        {source: 'Filtration/\nDay Tanks', target: 'Blowdown', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.FiltrationBlowdowngal,0)), lineStyle: {color: '#6B983C'}},
        {source: 'City Water', target: 'Filtration/\nDay Tanks', value: Math.round(cityWaterToFiltrationData), lineStyle: {opacity: 0.5, color: '#a8cfff'}},
        {source: 'City Water', target: 'Irrigation', value: Math.round(cityWaterToIrrigationData), lineStyle: {opacity: 0.5, color: '#a8cfff'}},
        // {source: 'Filtration', target: 'Water\nDemand', value: filtrationData - Math.round(this.filterData.reduce((total,arr)=>total+arr.FiltrationBlowdowngal,0)), lineStyle: {opacity: 0.5, color: '#a8cfff'}},
        {source: 'Filtration/\nDay Tanks', target: 'Fountains', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.WaterFountainsgal,0)),lineStyle: {opacity: .5}},
        {source: 'Filtration/\nDay Tanks', target: 'Toilets', value: Math.round(this.toiletKfactor*this.filterData.reduce((total,arr)=>total+arr.IntoCompostersgal + arr.Biosolidsgal*(1/this.toiletKfactor-1),0)),lineStyle: {opacity: .5}},
        {source: 'Filtration/\nDay Tanks', target: 'Sinks', value:  Math.round(sinkData), lineStyle: {opacity: .5}},
        {source: 'Filtration/\nDay Tanks', target: 'Showers', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Showersgal,0)),lineStyle: {opacity: .5}},
        {source: 'Filtration/\nDay Tanks', target: 'Misc.', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Miscellaneousgal,0)),lineStyle: {opacity: .5}},
        {source: 'Blowdown', target: 'Treatment', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.FiltrationBlowdowngal,0)),},
        // {source: 'Filler4', target: 'Urinals', value: 0.00001, lineStyle: {opacity: 0,}},
        // {source: 'Filler4', target: 'Blowdown', value: 0.00001, lineStyle: {opacity: 0,}},
        {source: 'Toilets', target: 'Composters', value:  Math.round(toiletData), lineStyle: {color: '#85503A'}},
        {source: 'Showers', target: 'Treatment', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.Showersgal,0)),lineStyle: {color: '#6B983C'}},
        {source: 'Sinks', target: 'Treatment', value:  Math.round(sinkData), lineStyle: {color: '#6B983C'}},
        {source: 'Misc.', target: 'Treatment', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Miscellaneousgal,0)),lineStyle: {color: '#6B983C'}},
        {source: 'Fountains', target: 'Consumption', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.Consumptiongal,0)),lineStyle: {opacity: .5}},
        {source: 'Fountains', target: 'Treatment', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.WaterFountainsgal-arr.Consumptiongal,0)),lineStyle: {color: '#6B983C'}},
        {source: 'Treatment', target: 'Constructed\nWetlands', value:  Math.round(treatmentData)},
        {source: 'Composters', target: 'Biosolids', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Biosolidsgal,0))},
        {source: 'Urinals', target: 'Leachate', value:  Math.round(this.filterData.reduce((total,arr)=>total+arr.Urinalsgalofpee,0))},
        {source: 'Composters', target: 'Leachate', value:  Math.round(this.toiletKfactor*this.filterData.reduce((total,arr)=>total+arr.LeavingCompostersasLeachategal,0))},
        {source: 'Irrigation', target: 'On-Site\nIrrigation', value: Math.round(this.filterData.reduce((total,arr)=>total+arr.RoofTopIrrigationNeedgal,0))},
      ];

      // if no composting, delete links to composters and biosolids and create sewer link
      if(!this.toiletName.includes('Compost')){
        linkData = linkData.filter(link => link.target !== 'Composters' && link.target !== 'Biosolids')
        linkData.splice(linkData.length,0,{source: 'Toilets', target: 'Sewers', value: Math.round(toiletData), itemStyle: {color:'#85503A'}});
      }
      // add link to connect rain collection to cistern fill if filling cistern
      if(Math.round(cisternFlowData) > 0){
        linkData.splice(0,1,{source: 'Rain\nCollection', target: 'Cistern\nFill', value: Math.round(cisternFlowData)});
      };

      // remove links that don't have any values
      linkData = linkData.filter(link => link.value !== 0);

      // if(Math.round(overflowData) == 0 && Math.round(Math.min(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0)-overflowData, this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0))) == 0 && Math.round(this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0)-Math.min(Math.round(this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0))-overflowData,Math.round(this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0)))) == 0){
      //   // if there isn't any rain to overflow or rain to condensate or cistern to Condensate, then have the filler1 to filler2 link (which creates a gap on top) be shrunk
      //   linkData.find((el)=>{return el.source == 'Filler1' && el.target == 'Filler2'}).value = 0.00001;
      // }

      return linkData;
    },
    refreshCisternVolumeChart: function(){
      this.cisternVolumeChart.showLoading();
      const cisternVolumeChartOption = {
        tooltip: {
          show: true,
          trigger: 'item',
          triggerOn: 'mousemove',
        },
        xAxis: {
          type: 'value',
          show: false,
          data: this.getCisternData[0],
        },
        yAxis: {
          type: 'value',
        },
        series: [
        {
            type: 'line',
            areaStyle: {},
            data: this.getCisternData[1],
        },
        ],
      };
      // console.log(cisternVolumeChartOption.series[0].data)
      this.cisternVolumeChart.setOption(cisternVolumeChartOption,true);
      this.cisternVolumeChart.hideLoading();
    },
    getWaterCorrections: function(){
      let waterDataCorrected = waterData.map(el => ({...el}));
      for(let i=0;i<waterData.length;i++){
        let el = waterDataCorrected[i];
        el.Toiletsgal = (this.toiletKfactor*(el.IntoCompostersgal + (1/this.toiletKfactor-1)*el.Biosolidsgal));
        el.Sinksgal = (this.faucetKfactor*el.Sinksgal);
        el.EnteringBuildinggal = (el.Toiletsgal + el.Miscellaneousgal + el.Showersgal + el.Sinksgal + el.WaterFountainsgal);
        if(i==0){
          //if first iteration, use the user specified cistern capacity
          el.CisternVolumegal = (1*this.cisternCapacity);
        }else{
          //else need to use previous cistern volume corrected number
          el.CisternVolumegal = (waterDataCorrected[i-1].CisternVolumegal);
        };
        // first take demand from rain
        el.rainBeingFiltered = Math.min(el.EnteringBuildinggal/(1-0.050200803), el.Rainbeingcapturedgal);
        el.rainToIrrigation = Math.min(el.Rainbeingcapturedgal - el.rainBeingFiltered, el.CisterntoCondensategal);
        el.rainBeingUsed = el.rainBeingFiltered + el.rainToIrrigation;
        // if rain isn't enough, then take from cistern
        // negative cistern flow indicates flowing out of cistern
        el.CisternToFiltrationgal = -1*Math.min(el.EnteringBuildinggal/(1-0.050200803) - el.rainBeingFiltered, el.CisternVolumegal);
        el.CisternToIrrigation = -1*Math.min(el.CisterntoCondensategal - el.rainToIrrigation, el.CisternVolumegal + el.CisternToFiltrationgal);
        el.CisternFlowgal = el.CisternToFiltrationgal + el.CisternToIrrigation;
        // if rain and cistern isn't enough, take from city water
        el.CityWatergal = Math.max(el.EnteringBuildinggal + el.CisterntoCondensategal - (el.rainBeingFiltered + -1*el.CisternToFiltrationgal)*(1-0.050200803) - (el.rainToIrrigation + -1*el.CisternToIrrigation),0);
        // total amount of water getting filtered
        // console.log(el.CisternFlowgal)
        // console.log(el.rainBeingFiltered)
        el.EnteringFiltrationgal = Math.max(-1*el.CisternToFiltrationgal,0) + el.rainBeingFiltered;
        // amount of water lost during filtration
        el.FiltrationBlowdowngal = 0.050200803*el.EnteringFiltrationgal;
        // if rain exceeds demand, there will be overflow
        // overflow first goes to filling up cistern
        el.CisternFlowgal = el.CisternFlowgal + Math.min(el.Rainbeingcapturedgal - el.rainBeingUsed,1*this.cisternCapacity-el.CisternVolumegal);
        // if water is going into cistern then account for that being taken from rain
        el.rainToCistern = Math.max(el.CisternFlowgal,0);
        el.rainBeingUsed = el.rainBeingUsed + el.rainToCistern;
        el.CisternVolumegal = el.CisternVolumegal + el.CisternFlowgal;
        // if overflow rain exceeds cistern then it goes to irrigation
        el.IrrigationOverflowgal = Math.max(el.Rainbeingcapturedgal - el.rainBeingUsed,0);
      }

      return waterDataCorrected;
    },
    getWaterTotals: function(){
      // console.log(this.filterData)
      let waterTotals = [];
      waterTotals.treatmentData = this.filterData.reduce((total,arr)=>total+arr.FiltrationBlowdowngal+arr.Sinksgal+arr.Showersgal+arr.Miscellaneousgal+arr.WaterFountainsgal-arr.Consumptiongal,0);
      waterTotals.toiletData = this.filterData.reduce((total,arr)=>total+arr.Toiletsgal,0);
      waterTotals.sinkData = this.filterData.reduce((total,arr)=>total+arr.Sinksgal,0);
      waterTotals.potableWaterTankData = this.filterData.reduce((total,arr)=>total+arr.EnteringBuildinggal,0);
      waterTotals.overflowData = this.filterData.reduce((total,arr)=>total+arr.IrrigationOverflowgal,0);
      waterTotals.cityWaterData = this.filterData.reduce((total,arr)=>total+arr.CityWatergal,0);
      waterTotals.filtrationData = this.filterData.reduce((total,arr)=>total+arr.EnteringFiltrationgal,0);
      // waterTotals.cisternFlowData = waterTotals.overflowData + waterTotals.filtrationData + this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0);
      // console.log(this.filterData)
      // waterTotals.cisternFlowData = this.filterData[0].CisternVolumegal-this.filterData[this.filterData.length-1].CisternVolumegal;
      waterTotals.cisternFlowData = this.filterData.reduce((total,arr)=>total+arr.CisternFlowgal,0);
      // waterTotals.rainUsedData = this.filterData.reduce((total,arr)=>total+arr.rainBeingFiltered+arr.rainToCistern,0)-waterTotals.cisternFlowData;
      waterTotals.rainCollectedData = this.filterData.reduce((total,arr)=>total+arr.Rainbeingcapturedgal,0);
      waterTotals.rainToOverflowData = this.filterData.reduce((total,arr)=>total+arr.IrrigationOverflowgal,0);
      let irrigationNeeded = this.filterData.reduce((total,arr)=>total+arr.CisterntoCondensategal,0);
      waterTotals.rainToIrrigationData = Math.min(waterTotals.rainCollectedData - waterTotals.rainToOverflowData,irrigationNeeded);
      waterTotals.rainToFiltrationData = waterTotals.rainCollectedData - waterTotals.rainToOverflowData - waterTotals.rainToIrrigationData - Math.max(waterTotals.cisternFlowData,0);
      waterTotals.cisternToIrrigationData = Math.min(Math.max(-1*waterTotals.cisternFlowData,0),irrigationNeeded - waterTotals.rainToIrrigationData);
      waterTotals.cisternToFiltrationData = Math.max(-1*waterTotals.cisternFlowData,0) - waterTotals.cisternToIrrigationData;
      waterTotals.cityWaterToIrrigationData = Math.min(waterTotals.cityWaterData,irrigationNeeded - waterTotals.rainToIrrigationData - waterTotals.cisternToIrrigationData);
      waterTotals.cityWaterToFiltrationData = waterTotals.cityWaterData - waterTotals.cityWaterToIrrigationData;
      // console.log('Irrigation Needed: ' + irrigationNeeded)
      // console.log('')
      return waterTotals;
    },
  },
  mounted: function () {
    echarts.registerTheme('shine', shine)
    this.waterSankey = echarts.init(this.$refs.waterSankey,'shine');
    this.waterSankey.on('click',{seriesIndex: 0},this.toggleData);
    this.refreshWaterSankey;
    // this.waterSankey.on('mouseover',{seriesIndex: 0, dataType: 'edge'}, (el)=>this.waterSankey.dispatchAction({type: 'showTip', seriesIndex: 0, name: el.name}));
    // this.waterSankey.dispatchAction({type: 'highlight',dataIndex: 0});
    // this.cisternVolumeChart = echarts.init(this.$refs.cisternVolumeChart,'shine');
    // this.refreshCisternVolumeChart;
    _.debounce(this.onResize,100)();
  }
}
</script>
